import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const quickActions = [
    {
      title: 'Manage Horses',
      description: 'Register a new horse for £5',
      icon: 'pi pi-plus',
      action: () => navigate('/horses'),
      color: 'secondary',
      label: 'Manage Horses'
    },
    {
      title: 'My Rides',
      description: 'Manage your ride details here',
      icon: 'pi pi-file',
      action: () => navigate('/rides'),
      color: 'secondary',
      label: 'Manage Rides'
    },
    {
      title: 'Book Event',
      description: 'Find and register for upcoming events',
      icon: 'pi pi-calendar',
      action: () => window.open('https://www.sportendurance.co.uk/events', '_blank'),
      color: 'tertiary',
      label: 'Book New Event'
    }
  ];

  return (
    <div>
      {/* Welcome Section */}
      <div className="se-card mb-4">
        <div className="se-card-header">
          <p><strong>{user?.member?.membership?.replace(/ [m|M]embership/g, '')} Membership <a href="https://www.sportendurance.co.uk/membership" className='text-primary'>(Change)</a></strong></p>
          <h1>Hello {user?.name || 'Member'}, Welcome to Sport Endurance Members Area</h1>
        </div>
        <div className="se-card-content">
          <p className="text-600 m-0">
            Here you can manage your horses and submit ride results data. Please use the main Sport Endurance website to book on to new events. Once booked, you can manage your rides here.
          </p>
        </div>
      </div>

      {/* Quick Actions Grid */}
      <div className="grid">
        {quickActions.map((action, index) => (
          <div key={index} className="col-12 md:col-6 lg:col-3">
            <Card className="h-full">
              <div className="text-center">
                <div className={`inline-flex align-items-center justify-content-center border-circle w-4rem h-4rem mb-3 se-bg-${action.color}`}>
                  <i className={`${action.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="mt-0 mb-2">{action.title}</h3>
                <p className="text-600 line-height-3 mb-3">{action.description}</p>
                <Button 
                  label={action.label}
                  className={`p-button-${action.color}`}
                  onClick={action.action}
                />
              </div>
            </Card>
          </div>
        ))}
      </div>

      {/* Recent Activity 
      <div className="grid mt-4">
        <div className="col-12 lg:col-8">
          <div className="se-card">
            <div className="se-card-header">
              <h3>Recent Activity</h3>
            </div>
            <div className="se-card-content">
              <div className="flex align-items-start p-3 border-bottom-1 border-200">
                <i className="pi pi-calendar se-text-secondary mr-3 mt-1"></i>
                <div>
                  <div className="font-medium">Event Registration</div>
                  <div className="text-sm text-600">Registered for Spring Endurance Ride - 2 days ago</div>
                </div>
              </div>
              <div className="flex align-items-start p-3 border-bottom-1 border-200">
                <i className="pi pi-file se-text-primary mr-3 mt-1"></i>
                <div>
                  <div className="font-medium">Document Upload</div>
                  <div className="text-sm text-600">Uploaded ride completion certificate - 5 days ago</div>
                </div>
              </div>
              <div className="flex align-items-start p-3">
                <i className="pi pi-plus se-text-tertiary mr-3 mt-1"></i>
                <div>
                  <div className="font-medium">Horse Registration</div>
                  <div className="text-sm text-600">Registered Thunder - 1 week ago</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-12 lg:col-4">
          <div className="se-card">
            <div className="se-card-header">
              <h3>Account Summary</h3>
            </div>
            <div className="se-card-content">
              <div className="flex justify-content-between align-items-center mb-3">
                <span>Active Memberships</span>
                <span className="font-bold se-text-primary">2</span>
              </div>
              <div className="flex justify-content-between align-items-center mb-3">
                <span>Registered Horses</span>
                <span className="font-bold se-text-secondary">3</span>
              </div>
              <div className="flex justify-content-between align-items-center mb-3">
                <span>Credits Available</span>
                <span className="font-bold se-text-tertiary">£45.00</span>
              </div>
              <div className="flex justify-content-between align-items-center">
                <span>Ride Documents</span>
                <span className="font-bold">12</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      */}
    </div>
  );
};

export default Dashboard;